import { IManagingLinuxServiceInstance } from '../../api/models';
import { AppEnvironment } from '../../constants/AppEnvironment';
import { LinuxServiceActiveState } from '../../constants/LinuxServiceActiveState';
import { LinuxServiceSubState } from '../../constants/LinuxServiceSubState';
import { IStyledText, StyledText } from '../UIExtentions/Text';

function GetSubStateProps(activeState: string, subState: string, environment: AppEnvironment): IStyledText {
    const calculateVariant = (className: string) => {
        if (activeState === LinuxServiceActiveState.Inactive) {
            return subState === LinuxServiceSubState.Running ? 'text-orange' : 'text-muted';
        }
        return className;
    };

    switch (subState) {
        case LinuxServiceSubState.Running:
            return {
                text: 'Running',
                className: calculateVariant('text-success'),
            };
        case LinuxServiceSubState.Exited:
            return {
                text: 'Exited',
                className: environment === AppEnvironment.Production ? calculateVariant('text-danger') : null,
            };
        case LinuxServiceSubState.Dead:
            return {
                text: 'Dead',
                className: environment === AppEnvironment.Production ? calculateVariant('text-danger') : null,
            };
        case LinuxServiceSubState.Failed:
            return {
                text: 'Failed',
                className: environment === AppEnvironment.Production ? calculateVariant('text-danger') : null,
            };
        case LinuxServiceSubState.StartPre:
            return {
                text: 'Start Pre',
                className: calculateVariant('text-orange'),
            };
        case LinuxServiceSubState.Start:
            return {
                text: 'Start',
                className: calculateVariant('text-orange'),
            };
        case LinuxServiceSubState.StartPost:
            return {
                text: 'Start Post',
                className: calculateVariant('text-orange'),
            };
        case LinuxServiceSubState.Stop:
            return {
                text: 'Stop',
                className: calculateVariant('text-orange'),
            };
        case LinuxServiceSubState.StopWatchdog:
            return {
                text: 'Stop Watchdog',
                className: calculateVariant('text-orange'),
            };
        case LinuxServiceSubState.StopSigterm:
            return {
                text: 'Stop Sigterm',
                className: calculateVariant('text-orange'),
            };
        case LinuxServiceSubState.StopSigkill:
            return {
                text: 'Stop Sigkill',
                className: calculateVariant('text-orange'),
            };
        case LinuxServiceSubState.StopPost:
            return {
                text: 'Stop Post',
                className: calculateVariant('text-orange'),
            };
        case LinuxServiceSubState.FinalWatchdog:
            return {
                text: 'Final Watchdog',
                className: calculateVariant('text-orange'),
            };
        case LinuxServiceSubState.FinalSigterm:
            return {
                text: 'Final Sigterm',
                className: calculateVariant('text-orange'),
            };
        case LinuxServiceSubState.FinalSigkill:
            return {
                text: 'Final Sigkill',
                className: calculateVariant('text-orange'),
            };
        case LinuxServiceSubState.Reload:
            return {
                text: 'Reload',
                className: calculateVariant('text-orange'),
            };
        case LinuxServiceSubState.AutoRestart:
            return {
                text: 'AutoRestart',
                className: calculateVariant('text-orange'),
            };
        case LinuxServiceSubState.Cleaning:
            return {
                text: 'Cleaning',
                className: calculateVariant('text-orange'),
            };
        case LinuxServiceSubState.Condition:
            return {
                text: 'Condition',
                className: calculateVariant('text-orange'),
            };
        default:
            return {
                text: subState,
            };
    }
}

export default function LinuxServiceSubStateText(serverApp: IManagingLinuxServiceInstance) {
    const stateProps = GetSubStateProps(serverApp.activeState, serverApp.subState, serverApp.environment as AppEnvironment);

    return <StyledText {...stateProps} />;
}
